export const inputCls =
  "w-full bg-ink border border-hairline rounded-lg px-3 py-2 font-mono text-sm text-txt focus:border-lav outline-none";
export const labelCls = "block font-mono text-[11px] uppercase tracking-wide text-mute mb-1.5 mt-3";
export const btn =
  "font-mono text-xs uppercase tracking-wide rounded-full px-4 py-2 transition-colors";
